<template>
    <div class="page">
        <header>
            <b-container>
                <!-- <div class="sec-title">
                    <b-row class="pb-2" style="padding-top:80px" align-v="center">
                        <b-col cols="auto">
                            <h4 class="mb-0" v-for="(item, index) in CategoryList" :key="index">{{ item.text }}</h4>
                        </b-col>
                        <b-col cols="auto">
                            <b-button @click="cFilter = !cFilter"> <b-icon icon="filter"></b-icon> 過濾</b-button>
                        </b-col>
                    </b-row>
                </div> -->
                <div class=" d-block mb-5">
                    <b-row align-v="center" v-show="filter2['categories'].show">
                        <b-col cols="12" md="9">
                            <b-nav pills class="categories atcourses">
                                <b-nav-item class="catalog" v-for="(item, index) in CategoryList" :key="index"
                                    @click="CategoryClick(item)" :active="CategoryId == item.Id">
                                    <div class="icon" :style="{
                                        'background-image':
                                            'url(' +
                                            $store.state.WebSite +
                                            'files/_category/' +
                                            item.Id +
                                            '/cover.png' +
                                            ')',
                                    }"></div>
                                    <span style="display:block">{{ item.Name }}</span>
                                </b-nav-item>
                            </b-nav>
                        </b-col>
                        <b-col class="d-none d-sm-block" md="3">
                            <b-img :src="$store.state.WebSite + 'files/_category/' + CategoryId + '/cover.png'"
                                fluid></b-img>
                        </b-col>
                    </b-row>
                </div>
            </b-container>
        </header>
        <div class="box image2 ">
            <b-container>
                <b-row class="justify-content-center">
                    <b-col cols="auto">
                        <h4 class="mb-4" style="font-weight: bold;" @click="filter2.show = !filter2.show">進階搜尋</h4>
                    </b-col>
                </b-row>

                <b-row class="mb-2">
                    <b-col cols="12" class="mb-1" md="auto">課程標籤</b-col>
                    <b-col>
                        <b-form-group class="filterItem">
                            <div :key="tagGroupRenderKey" class="d-flex flex-wrap">
                                <b-button
                                    v-for="tag in TagList"
                                    :key="tag"
                                    class="mr-2 mb-2"
                                    :class="{ active: isTagActive(tag) }"
                                    :pressed="isTagActive(tag)"
                                    :variant="isTagActive(tag) ? 'primary' : 'outline-primary'"
                                    @click="toggleTagSelection(tag)">
                                    {{ tag }}
                                </b-button>
                            </div>
                        </b-form-group>
                    </b-col>
                </b-row>
                <b-row class="mb-2">
                    <b-col cols="12" class="mb-1" md="auto">課程類型</b-col>
                    <b-col>
                        <b-form-group class="filterItem">
                            <b-form-checkbox-group v-model="Type" name="buttons-1" button-variant="outline-primary"
                                buttons>
                                <b-form-checkbox value="Credit">學分班課程</b-form-checkbox>
                                <b-form-checkbox value="Support">委訓班</b-form-checkbox>
                            </b-form-checkbox-group>
                        </b-form-group>
                    </b-col>
                </b-row>
                <b-row class="mb-2">
                    <b-col cols="12" class="mb-1" md="auto">課程狀態</b-col>
                    <b-col>
                        <b-form-group class="filterItem">
                            <b-form-radio-group v-model="State" name="buttons-1" button-variant="outline-primary"
                                buttons>
                                <b-form-radio value="true">開放報名中</b-form-radio>
                                <b-form-radio value="false">規劃中</b-form-radio>
                            </b-form-radio-group>
                        </b-form-group>
                    </b-col>
                </b-row>
            </b-container>
        </div>

        <!--*********************************************************************************-->
        <b-container class="py-3">
            <b-form-group class="mb-0 position-relative">
                <b-icon-search class="position-absolute"
                    style="left: 1rem; top: 50%; transform: translateY(-50%);"></b-icon-search>
                <b-input-group class="course-search">
                    <b-form-input id="input-1" v-model="keywords" type="text" placeholder="想學什麼？" required
                        style="padding-left: 2.5rem;;"></b-form-input>
                </b-input-group>
            </b-form-group>
        </b-container>
        <b-container class="pt-3 pt-md-5">
            <template v-if="Courses.load == false">
                <div class="loading">
                    <b-icon icon="three-dots" animation="cylon" font-scale="2" variant="white"></b-icon>
                </div>
            </template>

            <template v-else-if="showEmptyCourseAlert">
                <b-alert variant="warning" class="text-center" show>您查詢的類別或關鍵字沒有可顯示的課程。</b-alert>
            </template>
            <template v-else-if="Courses.data.length > 0">
                <b-alert v-if="showFallbackRecommendNotice" variant="info" class="mb-3" show>
                    您查詢的類別或關鍵字沒有顯示的課程，以下為推薦課程
                </b-alert>
                <div class="course-results-toolbar">
                    <b-button-group aria-label="課程瀏覽模式切換">
                        <b-button :pressed="Courses.displayType === 'grid'"
                            :variant="Courses.displayType === 'grid' ? 'primary' : 'outline-primary'"
                            v-b-tooltip.hover title="網格瀏覽" @click="setDisplayType('grid')">
                            <b-icon-grid-3x3-gap></b-icon-grid-3x3-gap>
                        </b-button>
                        <b-button :pressed="Courses.displayType === 'list'"
                            :variant="Courses.displayType === 'list' ? 'primary' : 'outline-primary'"
                            v-b-tooltip.hover title="列表瀏覽" @click="setDisplayType('list')">
                            <b-icon-list-ul></b-icon-list-ul>
                        </b-button>
                    </b-button-group>
                </div>
                <b-row :cols-lg="Courses.displayType === 'grid' ? 3 : 1"
                    :class="['courses', Courses.displayType]">
                    <b-col @click="Detail(course.Id)"
                        :class="Courses.displayType === 'grid' ? 'mb-4' : 'mb-3'"
                        v-for="(course, index) in Courses.data" :key="index">
                        <b-card img-alt="Image" tag="article" class="course" no-body>
                            <figure class="ratio-1440x452 bg-blur mb-0 course-figure"
                                style="object-fit: contain !important; object-position: center;" :style="{
                                    '--bg-url': `url('${$store.state.FilePath}files/_course/${course.Id}/cover.png')`,
                                }">
                                <b-button
                                    variant="light"
                                    size="sm"
                                    class="favorite-icon-button"
                                    :disabled="isFavoritePending(course)"
                                    @click.stop.prevent="toggleFavorite(course)"
                                >
                                    <b-icon-heart-fill v-if="isFavorite(course)" variant="danger"></b-icon-heart-fill>
                                    <b-icon-heart v-else variant="danger"></b-icon-heart>
                                </b-button>
                                <b-card-img v-if="course.Cover != ''" class="ratio-1440x452"
                                    style="object-fit: contain !important; object-position: center;"
                                    :src="$store.state.FilePath + 'files/_course/' + course.Id + '/cover.png'"></b-card-img>
                                <b-card-img v-else src="./asset/no-image.png"
                                    style="height: 100% !important; object-fit: cover !important; object-position: center;"></b-card-img>
                                <!-- <div v-if="isApplyNow(course)" class="course-badge">報名中</div> -->
                            </figure>

                            <b-card-body>
                                <div class="mb-2 course-category-row" v-if="Courses.displayType === 'grid' && course.Category">
                                    課程類別：<b-badge class="mr-1">
                                        {{ course.Category }}
                                    </b-badge>
                                </div>
                                <div class="mt-3 d-flex flex-wrap align-items-center"
                                    v-if="Courses.displayType === 'list' && course.Category">
                                    <span class="mr-2 course-meta-label">課程類別：</span>
                                    <b-badge class="mr-1 mb-1 course-category-badge">{{ course.Category }}</b-badge>
                                </div>
                                <div v-else class="mt-3"></div>
                               
                                <b-card-title title-tag="h5" class="clamp-2">
                                    <b-badge v-if="course.IsRecommend" variant="warning" class="mr-2 course-recommend-badge d-none">
                                        推薦
                                    </b-badge>
                                    {{ course.Name }}
                                </b-card-title>
                                <small class="clamp-3"
                                    style="color: #888;display: -webkit-box;-webkit-box-orient: vertical;-webkit-line-clamp: 3;overflow: hidden;"
                                    v-html="course.Introduction"></small>
                                 <div class="mt-2 d-flex flex-wrap">
                                    <b-badge class="mr-1 mb-1" v-for="(tag, index) in course.Tags" :key="index">
                                        {{ tag }}
                                </b-badge>
                                </div>
                            </b-card-body>

                            <b-card-footer class="text-right">
                                <div class="signin">
                                    <div class="course-price-box">
                                        <span v-if="isApplyNow(course)" class="course-badge course-badge-list">報名中</span>
                                        <div class="course-price-text">
                                            <div class="course-price-original">
                                                <span class="mr-2">原價</span>
                                                <span class="price old-price">
                                                    NT${{ course.OrginalPrice | money(0, 2) }}
                                                </span>
                                            </div>
                                            <div class="course-price-current">
                                                <span class="number">NT${{ course.Price | money(0, 2) }}</span>
                                            </div>
                                        </div>
                                    </div>
                                    <ul class="list-unstyled mb-0">
                                        <li class="d-flex align-items-center justify-content-between">
                                            <div class="d-flex flex-wrap align-items-start justify-content-between">
                                                <span class="mr-2">原價</span>
                                                <span class="price" style="text-decoration:line-through;color: #888;">
                                                    NT${{ course.OrginalPrice | money(0, 2) }}
                                                </span>
                                            </div>

                                            <span class="price">
                                                <span v-if="isApplyNow(course)" class="course-badge mr-2">報名中</span>
                                                <span class="number">NT${{ course.Price | money(0, 2) }}</span>
                                            </span>
                                        </li>
                                    </ul>
                                    <b-button v-if="course.canSignin" block variant="primary" class="my-2"
                                        @click="butGo(0, course)">我要報名</b-button>
                                </div>
                            </b-card-footer>
                        </b-card>
                    </b-col>
                </b-row>
                <section v-if="showBottomRecommendSection" class="mt-5">
                    <h4 class="mb-4">推薦課程</h4>
                    <b-row :cols-lg="Courses.displayType === 'grid' ? 3 : 1"
                        :class="['courses', Courses.displayType]">
                        <b-col @click="Detail(course.Id)"
                            :class="Courses.displayType === 'grid' ? 'mb-4' : 'mb-3'"
                            v-for="(course, index) in Courses.recommendedData" :key="`recommend-${index}`">
                            <b-card img-alt="Image" tag="article" class="course" no-body>
                                <figure class="ratio-1440x452 bg-blur mb-0 course-figure"
                                    style="object-fit: contain !important; object-position: center;" :style="{
                                        '--bg-url': `url('${$store.state.FilePath}files/_course/${course.Id}/cover.png')`,
                                    }">
                                    <b-button
                                        variant="light"
                                        size="sm"
                                        class="favorite-icon-button"
                                        :disabled="isFavoritePending(course)"
                                        @click.stop.prevent="toggleFavorite(course)"
                                    >
                                        <b-icon-heart-fill v-if="isFavorite(course)" variant="danger"></b-icon-heart-fill>
                                        <b-icon-heart v-else variant="danger"></b-icon-heart>
                                    </b-button>
                                    <b-card-img v-if="course.Cover != ''" class="ratio-1440x452"
                                        style="object-fit: contain !important; object-position: center;"
                                        :src="$store.state.FilePath + 'files/_course/' + course.Id + '/cover.png'"></b-card-img>
                                    <b-card-img v-else src="./asset/no-image.png"
                                        style="height: 100% !important; object-fit: cover !important; object-position: center;"></b-card-img>
                                </figure>

                                <b-card-body>
                                    <div class="mb-2 course-category-row" v-if="Courses.displayType === 'grid' && course.Category">
                                        <b-badge class="mr-1">
                                            {{ course.Category }}
                                        </b-badge>
                                    </div>
                                    <div class="mt-3 d-flex flex-wrap align-items-center"
                                        v-if="Courses.displayType === 'list' && course.Category">
                                        <span class="mr-2 course-meta-label">課程類別：</span>
                                        <b-badge class="mr-1 mb-1 course-category-badge">{{ course.Category }}</b-badge>
                                    </div>
                                    <div v-else class="mt-3"></div>
                                
                                    <b-card-title title-tag="h5" class="clamp-2">
                                        <b-badge v-if="course.IsRecommend" variant="warning" class="mr-2 course-recommend-badge d-none">
                                            推薦
                                        </b-badge>
                                        {{ course.Name }}
                                    </b-card-title>
                                    <small class="clamp-3"
                                        style="color: #888;display: -webkit-box;-webkit-box-orient: vertical;-webkit-line-clamp: 3;overflow: hidden;"
                                        v-html="course.Introduction"></small>
                                    <div class="mt-2 d-flex flex-wrap">
                                        <b-badge class="mr-1 mb-1" v-for="(tag, tagIndex) in course.Tags" :key="tagIndex">
                                            {{ tag }}
                                        </b-badge>
                                    </div>
                                </b-card-body>

                                <b-card-footer class="text-right">
                                    <div class="signin">
                                        <div class="course-price-box">
                                            <span v-if="isApplyNow(course)" class="course-badge course-badge-list">報名中</span>
                                            <div class="course-price-text">
                                                <div class="course-price-original">
                                                    <span class="mr-2">原價</span>
                                                    <span class="price old-price">
                                                        NT${{ course.OrginalPrice | money(0, 2) }}
                                                    </span>
                                                </div>
                                                <div class="course-price-current">
                                                    <span class="number">NT${{ course.Price | money(0, 2) }}</span>
                                                </div>
                                            </div>
                                        </div>
                                        <ul class="list-unstyled mb-0">
                                            <li class="d-flex align-items-center justify-content-between">
                                                <div class="d-flex flex-wrap align-items-start justify-content-between">
                                                    <span class="mr-2">原價</span>
                                                    <span class="price" style="text-decoration:line-through;color: #888;">
                                                        NT${{ course.OrginalPrice | money(0, 2) }}
                                                    </span>
                                                </div>

                                                <span class="price">
                                                    <span v-if="isApplyNow(course)" class="course-badge mr-2">報名中</span>
                                                    <span class="number">NT${{ course.Price | money(0, 2) }}</span>
                                                </span>
                                            </li>
                                        </ul>
                                        <b-button v-if="course.canSignin" block variant="primary" class="my-2"
                                            @click="butGo(0, course)">立即報名</b-button>
                                    </div>
                                </b-card-footer>
                            </b-card>
                        </b-col>
                    </b-row>
                </section>
                <!-- <b-row v-show="page.count <= Courses.data.length">
                    <b-col>
                        <b-pagination v-model="page.val" :total-rows="page.rows"
                            :per-page="page.perPage"></b-pagination>
                    </b-col>
                </b-row> -->
            </template>
        </b-container>
    </div>
</template>

<script>
import { apiDictionary, apiCourseList } from '@/api/API.js';
import courseFavorite from '@/mixins/courseFavorite.js';
export default {
    name: 'coursesPa',
    mixins: [courseFavorite],

    data() {
        return {
            keywords: '',
            AllParam: this.$store.state.AllParam,
            CategoryList: [],
            CategoryId: 'b51c78b2-bf21-4555-84b5-c150b4cb613e',
            Tags: [],
            Type: [],
            State: [],
            TagList: [],
            pendingRouteTags: [],
            isSyncingRouteTag: false,
            skipNextTagWatcher: false,
            tagGroupRenderKey: 0,
            //

            filter2: {
                show: true,
                categories: {
                    categoriesBg: '',
                    val: '',
                    data: [],
                    show: true,
                },
                hashtags: {
                    val: [],
                    options: [],
                    optionsAll: [],
                    set2(th1, if_list) {
                        let options = [];
                        //let val=[]
                        for (let i in th1.optionsAll) {
                            let item = th1.optionsAll[i];
                            if (if_list.indexOf(item.value) != -1) {
                                options.push(item);
                            }
                        }
                        th1.options = options;
                    },
                },
                courseType: {
                    val: [],
                    options: [],
                    optionsAll: [
                        { text: '非學分班課程', value: '非學分班課程' },
                        { text: '學分班課程', value: '學分班課程' },
                        { text: '委訓班', value: '委訓班' },
                    ],
                    set2(th1, if_list) {
                        let options = [];
                        for (let i in th1.optionsAll) {
                            let item = th1.optionsAll[i];
                            if (if_list.indexOf(item.value) != -1) {
                                options.push(item);
                            }
                        }
                        th1.options = options;
                    },
                },
                courseStatus: {
                    val: [],
                    options: [],
                    optionsAll: [
                        { text: '規劃中', value: '規劃中' },
                        { text: '已截止', value: '已截止' },
                        { text: '招生中', value: '招生中' },
                        { text: '已成班', value: '已成班' },
                        { text: '開課中', value: '開課中' },
                        { text: '早鳥優惠', value: '早鳥優惠' },
                        { text: '仍可報名', value: '仍可報名' },
                        { text: '已結束', value: '已結束' },
                        { text: '最新課程', value: '最新課程' },
                        { text: '熱門課程', value: '熱門課程' },
                    ],
                    set2(th1, if_list) {
                        let options = [];
                        //let val=[]
                        for (let i in th1.optionsAll) {
                            let item = th1.optionsAll[i];
                            if (if_list.indexOf(item.value) != -1) {
                                options.push(item);
                            }
                        }
                        th1.options = options;
                    },
                },
                keyword: '',
            },
            Courses: {
                title: '課程資料',
                load: false,
                displayType: 'grid',
                isFallbackRecommend: false,
                dataAll: [],
                data: [],
                recommendedData: [],
            },
            page: {
                val: 1,
                rows: 3,
                perPage: 1,
                count: 21,
                reData(th1, data) {
                    let list = [];
                    let n1 = th1.count * (th1.val - 1);
                    for (let i = n1; i < n1 + th1.count; i++) {
                        if (i > data.length - 1) {
                            break;
                        }
                        list.push(data[i]);
                    }
                    return list;
                },
                set(th1, length, count) {
                    th1.val = 1;
                    th1.rows = Math.ceil(length / count);
                    th1.count = count;
                },
            },
        };
    },
    created() { },
    computed: {
        showFallbackRecommendNotice() {
            return this.Courses.isFallbackRecommend === true && this.Courses.data.length > 0;
        },
        showEmptyCourseAlert() {
            return this.Courses.load && this.Courses.data.length === 0 && !this.Courses.isFallbackRecommend;
        },
        showBottomRecommendSection() {
            return this.hasActiveSearchCriteria
                && this.Courses.isFallbackRecommend === false
                && this.Courses.data.length > 0
                && this.Courses.recommendedData.length > 0;
        },
        hasActiveSearchCriteria() {
            const hasKeyword = typeof this.keywords === 'string' && this.keywords.trim() !== '';
            const hasSelectedTags = (Array.isArray(this.Tags) && this.Tags.length > 0)
                || (Array.isArray(this.pendingRouteTags) && this.pendingRouteTags.length > 0);
            const hasCourseType = (Array.isArray(this.Type) && this.Type.length > 0)
                || this.AllParam?.Search?.Credit === true
                || this.AllParam?.Search?.Support === true;
            const hasCourseStatus = Array.isArray(this.State)
                ? this.State.length > 0
                : this.State !== '' && this.State !== null && this.State !== undefined;
            const hasCategory = typeof this.AllParam?.Search?.category === 'string'
                && this.AllParam.Search.category !== '';

            return Boolean(
                hasKeyword ||
                hasSelectedTags ||
                hasCourseType ||
                hasCourseStatus ||
                hasCategory,
            );
        },
    },
    async mounted() {
        await this.Init();
        this.loadFavoriteProducts();
        if (!this.$route.query.keywords) {
            this.AllParam.Search.keywords = '';
        }
        if (!this.$route.query.tag) {
            this.AllParam.Search.tag = '';
        }
    },
    watch: {
        async '$route.query.tag'(newVal) {
            await this.handleRouteTagChange(newVal);
        },
        '$route.query.keywords'(newVal) {
            this.keywords = newVal || '';
            if (this.keywords != '') {
                this.AllParam.Search.keywords = encodeURI(this.keywords);
            } else {
                this.AllParam.Search.keywords = encodeURI(this.Tags);
            }
            this.GetList();
        },
        Tags(newVal) {
            this.Courses.load = false;
            if (this.skipNextTagWatcher) {
                this.skipNextTagWatcher = false;
                return;
            }
            if (this.isSyncingRouteTag) {
                this.tagGroupRenderKey += 1;
                return;
            }
            this.syncSearchTag(newVal);
            this.pendingRouteTags = Array.isArray(newVal) ? [...newVal] : [];
            this.GetList(true);
        },
        Type(newVal) {
            this.Courses.load = false;
            console.log(newVal);
            if (newVal.includes('Credit')) {
                this.AllParam.Search.Credit = true;
            } else {
                this.AllParam.Search.Credit = false;
            }
            if (newVal.includes('Support')) {
                this.AllParam.Search.Support = true;
            } else {
                this.AllParam.Search.Support = false;
            }

            this.GetList();
        },
        State(newVal) {
            console.log(newVal);
            this.AllParam.Search.new = newVal;
            this.GetList();
        },
        keywords(newVal) {
            if (newVal != '') {
                if (this.Tags.length > 0) {
                    this.AllParam.Search.keywords = encodeURI(newVal) + ',' + encodeURI(this.Tags);
                    this.GetList();
                } else {
                    this.AllParam.Search.keywords = encodeURI(newVal);
                    this.GetList();
                }
            } else {
                this.AllParam.Search.keywords = encodeURI(this.Tags);
                this.GetList();
            }
        },
    },
    methods: {
        normalizeTagValue(tag) {
            return typeof tag === 'string' ? tag.trim() : `${tag || ''}`.trim();
        },
        normalizeRouteTagQuery(tagQuery) {
            if (Array.isArray(tagQuery)) {
                return tagQuery.map((item) => this.normalizeTagValue(item)).filter(Boolean);
            }

            if (typeof tagQuery !== 'string') {
                return [];
            }

            return tagQuery
                .split(',')
                .map((item) => this.normalizeTagValue(item))
                .filter(Boolean);
        },
        syncSearchTag(tags) {
            const normalizedTags = Array.isArray(tags)
                ? tags.map((item) => this.normalizeTagValue(item)).filter(Boolean)
                : [];
            // The current backend still matches against ClassDetail.Tags with a Contains query.
            // Keep sending raw tag text for now so homepage hot-tag routing stays compatible.
            this.AllParam.Search.tag = normalizedTags.length > 0 ? encodeURI(normalizedTags.join(',')) : '';
        },
        areSameTags(left, right) {
            if (left.length !== right.length) {
                return false;
            }

            return left.every((tag, index) => tag === right[index]);
        },
        matchesSelectedTag(tagOption, selectedTag) {
            if (!tagOption || !selectedTag) {
                return false;
            }

            const normalizedTagOption = this.normalizeTagValue(tagOption);
            const normalizedSelectedTag = this.normalizeTagValue(selectedTag);

            return normalizedTagOption === normalizedSelectedTag
                || normalizedTagOption.includes(normalizedSelectedTag)
                || normalizedSelectedTag.includes(normalizedTagOption);
        },
        isTagActive(tag) {
            const activeSourceTags = this.Tags.length > 0 ? this.Tags : this.pendingRouteTags;
            return activeSourceTags.some((selectedTag) => this.matchesSelectedTag(tag, selectedTag));
        },
        toggleTagSelection(tag) {
            const normalizedTag = this.normalizeTagValue(tag);
            const nextTags = this.Tags.filter(
                (selectedTag) => this.normalizeTagValue(selectedTag) !== normalizedTag,
            );

            if (nextTags.length === this.Tags.length) {
                nextTags.push(normalizedTag);
            }

            this.Tags = nextTags;
        },
        async syncSelectedTagsFromResults(nextTags) {
            const sourceTags = this.pendingRouteTags.length > 0 ? this.pendingRouteTags : this.Tags;
            const matchedTags = nextTags.filter((tagOption) =>
                sourceTags.some((selectedTag) => this.matchesSelectedTag(tagOption, selectedTag)),
            );

            if (this.areSameTags(this.Tags, matchedTags)) {
                return matchedTags;
            }

            this.isSyncingRouteTag = true;
            await this.$nextTick();
            this.Tags = matchedTags;
            this.tagGroupRenderKey += 1;
            this.isSyncingRouteTag = false;
            return matchedTags;
        },
        buildCourseListParams(tagValue = this.AllParam.Search.tag) {
            return {
                ...this.AllParam,
                Search: {
                    ...this.AllParam.Search,
                    tag: tagValue,
                },
            };
        },
        buildRecommendCourseListParams() {
            return {
                ...this.AllParam,
                Search: {
                    ...this.AllParam.Search,
                    keywords: '',
                    tag: '',
                    category: '',
                    Credit: false,
                    Support: false,
                    new: '',
                },
            };
        },
        applyRouteTag(tagQuery) {
            const nextTags = this.normalizeRouteTagQuery(tagQuery);
            this.pendingRouteTags = nextTags;
            this.skipNextTagWatcher = true;
            this.Tags = [];
            this.syncSearchTag(nextTags);
        },
        async prefetchAvailableTags() {
            const res = await apiCourseList(this.buildCourseListParams(''));
            const normalizedResponse = this.normalizeCourseListResponse(res.data);
            const courses = normalizedResponse.courses.map((course, index) =>
                this.normalizeCourseItem(course, index),
            );
            const nextTags = this.extractCourseTags(courses);
            this.TagList = nextTags;
            this.tagGroupRenderKey += 1;
            await this.$nextTick();
            return this.syncSelectedTagsFromResults(nextTags);
        },
        async handleRouteTagChange(tagQuery) {
            const nextTags = this.normalizeRouteTagQuery(tagQuery);
            this.applyRouteTag(tagQuery);

            if (nextTags.length > 0) {
                const matchedTags = await this.prefetchAvailableTags();
                this.syncSearchTag(matchedTags.length > 0 ? matchedTags : nextTags);
                this.GetList(true);
                return;
            }

            this.GetList(false);
        },
        normalizeCourseListResponse(payload) {
            if (Array.isArray(payload)) {
                return {
                    courses: payload,
                    isFallbackRecommend: null,
                };
            }

            const courses = Array.isArray(payload?.data)
                ? payload.data
                : Array.isArray(payload?.Data)
                    ? payload.Data
                    : Array.isArray(payload?.items)
                        ? payload.items
                        : Array.isArray(payload?.Items)
                            ? payload.Items
                            : [];

            return {
                courses,
                isFallbackRecommend: typeof payload?.isFallbackRecommend === 'boolean'
                    ? payload.isFallbackRecommend
                    : typeof payload?.IsFallbackRecommend === 'boolean'
                        ? payload.IsFallbackRecommend
                        : null,
            };
        },
        parseListHeader(headers) {
            const listHeader = headers?.['list-header'] || headers?.['List-Header'];
            if (!listHeader) {
                return null;
            }

            try {
                return JSON.parse(listHeader);
            } catch (err) {
                console.log(err);
                return null;
            }
        },
        normalizeCourseTags(tags) {
            if (Array.isArray(tags)) {
                return tags;
            }

            if (typeof tags !== 'string' || tags === '') {
                return [];
            }

            try {
                const parsedTags = JSON.parse(tags);
                return Array.isArray(parsedTags) ? parsedTags : [];
            } catch (err) {
                return [];
            }
        },
        normalizeCourseItem(course, index) {
            const recommendSortRaw = course?.RecommendSort;
            const recommendSort = recommendSortRaw === null || recommendSortRaw === undefined || recommendSortRaw === ''
                ? Number.MAX_SAFE_INTEGER
                : Number(recommendSortRaw);

            return {
                ...course,
                Tags: this.normalizeCourseTags(course?.Tags),
                IsRecommend: course?.IsRecommend === true || course?.IsRecommend === 1 || course?.IsRecommend === 'true',
                RecommendSort: Number.isFinite(recommendSort) ? recommendSort : Number.MAX_SAFE_INTEGER,
                __originalIndex: index,
            };
        },
        normalizeCourseCollection(courses) {
            let normalizedCourses = courses.map((course, index) =>
                this.normalizeCourseItem(course, index),
            );

            if (this.shouldApplyRecommendSort(normalizedCourses)) {
                normalizedCourses = [...normalizedCourses].sort((a, b) => this.compareRecommendCourseOrder(a, b));
            }

            return normalizedCourses.map((course) => {
                const normalizedCourse = { ...course };
                delete normalizedCourse.__originalIndex;
                return normalizedCourse;
            });
        },
        compareRecommendCourseOrder(a, b) {
            if (a.IsRecommend !== b.IsRecommend) {
                return a.IsRecommend ? -1 : 1;
            }

            if (a.IsRecommend && b.IsRecommend && a.RecommendSort !== b.RecommendSort) {
                return a.RecommendSort - b.RecommendSort;
            }

            return a.__originalIndex - b.__originalIndex;
        },
        shouldApplyRecommendSort(courses) {
            const hasRecommendMeta = courses.some((course) => course.IsRecommend || course.RecommendSort !== Number.MAX_SAFE_INTEGER);
            if (!hasRecommendMeta) {
                return false;
            }

            for (let i = 1; i < courses.length; i++) {
                if (this.compareRecommendCourseOrder(courses[i - 1], courses[i]) > 0) {
                    return true;
                }
            }

            return false;
        },
        extractCourseTags(courses) {
            const tagList = [];

            for (let i = 0; i < courses.length; i++) {
                for (let a = 0; a < courses[i].Tags.length; a++) {
                    const normalizedTag = this.normalizeTagValue(courses[i].Tags[a]);
                    if (normalizedTag && !tagList.includes(normalizedTag)) {
                        tagList.push(normalizedTag);
                    }
                }
            }

            return tagList;
        },
        async updateCourseTags(courses, preserveCurrentTagList = false) {
            const nextTags = this.extractCourseTags(courses);
            if (!preserveCurrentTagList || this.TagList.length === 0) {
                this.TagList = nextTags;
                this.tagGroupRenderKey += 1;
            }
            await this.$nextTick();
            await this.syncSelectedTagsFromResults(preserveCurrentTagList ? this.TagList : nextTags);
        },
        inferFallbackRecommend(courses, explicitFlag) {
            if (typeof explicitFlag === 'boolean') {
                return explicitFlag;
            }

            if (!this.hasActiveSearchCriteria || courses.length === 0) {
                return false;
            }

            return courses.every((course) => course.IsRecommend === true);
        },
        setDisplayType(type) {
            this.Courses.displayType = type;
        },
        isApplyNow(item) {
            if (!item) return false;
            const start = item.ApplyStart ? new Date(item.ApplyStart) : null;
            const end = item.ApplyEnd ? new Date(item.ApplyEnd) : null;
            if (!start || !end || isNaN(start.getTime()) || isNaN(end.getTime())) return false;
            const now = new Date();
            const endAt = new Date(end.getTime());
            if (endAt.getHours() === 0 && endAt.getMinutes() === 0 && endAt.getSeconds() === 0) {
                endAt.setHours(23, 59, 59, 999);
            }
            return now >= start && now <= endAt;
        },
        Init() {
            apiDictionary('class', 'category')
                .then((res) => {
                    this.CategoryList = res.data;
                    // 將"全部課程"移到第一個位置
                    const allCoursesIndex = this.CategoryList.findIndex((item) => item.Name === '全部課程');
                    if (allCoursesIndex !== -1) {
                        const allCourses = this.CategoryList.splice(allCoursesIndex, 1)[0];
                        this.CategoryList.unshift(allCourses);
                    }
                    if (this.$route.query.category) {
                        this.AllParam.Search.category = encodeURI(this.$route.query.category);
                        for (let i = 0; i < this.CategoryList.length; i++) {
                            if (this.$route.query.category == this.CategoryList[i].Name) {
                                this.CategoryId = this.CategoryList[i].Id;
                            }
                        }
                    }
                    if (this.$route.query.keywords) {
                        this.AllParam.Search.keywords = encodeURI(this.$route.query.keywords);
                        this.keywords = this.$route.query.keywords;
                    }
                    // this.CategoryId = this.$route.query.C_Id;
                    this.handleRouteTagChange(this.$route.query.tag);
                })
                .catch((err) => {
                    console.log(err);
                    //alert(err.response.data);
                });
        },
        async fetchRecommendCourses(excludeCourseIds = []) {
            const res = await apiCourseList(this.buildRecommendCourseListParams());
            const normalizedResponse = this.normalizeCourseListResponse(res.data);
            const recommendCourses = this.normalizeCourseCollection(normalizedResponse.courses)
                .filter((course) => course.IsRecommend)
                .filter((course) => !excludeCourseIds.includes(course.Id));

            return recommendCourses.slice(0, 6);
        },
        async GetList(preserveCurrentTagList = false) {
            this.Courses.load = false;
            this.Courses.isFallbackRecommend = false;
            this.Courses.recommendedData = [];
            try {
                const res = await apiCourseList(this.buildCourseListParams());
                const listHeader = this.parseListHeader(res.headers);
                const normalizedResponse = this.normalizeCourseListResponse(res.data);
                const headerFallbackRecommend = typeof listHeader?.isFallbackRecommend === 'boolean'
                    ? listHeader.isFallbackRecommend
                    : typeof listHeader?.IsFallbackRecommend === 'boolean'
                        ? listHeader.IsFallbackRecommend
                        : null;
                const courses = this.normalizeCourseCollection(normalizedResponse.courses);

                this.Courses.isFallbackRecommend = this.inferFallbackRecommend(
                    courses,
                    headerFallbackRecommend !== null
                        ? headerFallbackRecommend
                        : normalizedResponse.isFallbackRecommend,
                );
                this.Courses.data = courses;
                this.Courses.dataAll = courses;
                await this.updateCourseTags(courses, preserveCurrentTagList);

                if (this.hasActiveSearchCriteria && !this.Courses.isFallbackRecommend && courses.length > 0) {
                    this.Courses.recommendedData = await this.fetchRecommendCourses(
                        courses.map((course) => course.Id),
                    );
                }

                this.Courses.load = true;
            } catch (err) {
                console.log(err);
                //alert(err.response.data);
            }
        },
        CategoryClick(data) {
            this.CategoryId = data.Id;
            this.TagList = [];
            if (data.Name == '全部課程') {
                this.AllParam.Search.category = '';
                this.GetList();
            } else {
                this.AllParam.Search.category = encodeURI(data.Name);
                this.keywords = '';
                this.AllParam.Search.keywords = '';
                this.$router.replace({ query: { ...this.$route.query, keywords: '' } });
                this.GetList();
            }
        },

        Detail(id) {
            this._go(this.LocaPath.default + 'course?Id=' + id);
        },
        filterF1() { },
        // session
        sessionF1(url, data) {
            if (this.IsNull(url) == '') {
                //let data1 = this._go2({ key: "CAT_ID" }, "query");
                let data1 = this._sessionData('CAT_ID');
                if (this.IsNull(data1) != '') {
                    this.data_in['CAT_ID'] = data1;
                }
                //let data2=this._go2({ key: "keyword" }, "query");
                let data2 = this._sessionData('keyword');
                if (this.IsNull(data2) != '') {
                    this.data_in['keyword'] = data2;
                    this.filter2['keyword'] = data2;
                    this.categoryClose();
                }
                let data3 = this._sessionData('courseStatus');
                if (this.IsNull(data3) != '') {
                    this.data_in['courseStatus'] = data3;
                    this.filter2['courseStatus'].val.push(data3);
                }
                this._sessionData('CAT_ID', '');
                this._sessionData('keyword', '');
                this._sessionData('courseStatus', '');
            } else if (url == 'course') {
                let url = this.LocaPath.default + 'course?CP_ID={CP_ID}';
                this._go1(this.Str_Replace(url, '{CP_ID}', data), 1);
            } else if (url == 'courseSignup') {
                this._go2(
                    {
                        path: '/courseSignup',
                        data: { CP_ID: data.CP_ID, RF_IS_GROUP: data.RF_IS_GROUP },
                    },
                    'query',
                );
            }
        },

        // 日期樣態調整
        turnDate: function (date) {
            if (this.IsNull(date) == '') {
                return '';
            }
            let newDate = new Date(date);
            return newDate.getFullYear() + '年' + (newDate.getMonth() + 1) + '月' + newDate.getDate() + '日';
        },

        categoryShow() {
            this.filter2['keyword'] = '';
            this.filter2['categories'].show = true;
            this.filterF1();
        },
        categoryClose() {
            this.filter2['categories'].show = false;
        },

        // 來去報名
        butGo(type, data) {
            if (data.canSignin == false) {
                alert('未開放報名');
                return;
            }
            if (this.IsNull(this._sessionData('TokenID')) == '') {
                //alert("尚未登入");
                let fun1 = this._storeData('LoginF1');
                if (this.IsNull(fun1) != '') {
                    let path1 = this.$route.path;
                    this._storeData('LoginFUN', (path2, err) => {
                        if (path1 == path2) {
                            this.sessionF1('courseSignup', {
                                CP_ID: data.CP_ID,
                                RF_IS_GROUP: type,
                            });
                        } else if (this.IsNull(err) != '') {
                            err();
                        }
                        this._storeData('LoginFUN', '');
                    });
                    fun1();
                }
                return;
            }
            this.sessionF1('courseSignup', {
                CP_ID: data.CP_ID,
                RF_IS_GROUP: type,
            });
        },

        // 來去看課程詳細資訊
        TableGo(data) {
            this.sessionF1('course', data);
        },

        Re_html(val) {
            if (this.IsNull(val) === '') {
                return '';
            }

            return this.Str_Replace2(val, [
                { old: '\r\n', new: '<br>' },
                { old: '\n', new: '<br>' },
            ]);
        },
        //===============================================================================
        // API
        // 取得課程
        FunctionGetCourseFeriodListByIndex_mini(data_in) {
            this.apiGetCourseFeriodListByIndex_mini(data_in)
                .then((res) => {
                    let json = JSON.parse(res.data);
                    if (json.Status) {
                        let courses = JSON.parse(json.Data);
                        if (this.IsNull(courses) != '' && courses.length != 0) {
                            //let curr = Date.parse(new Date().toDateString());
                            let imgUrl = [];
                            for (let i in courses) {
                                let course = courses[i];

                                if (this.IsNull(course.CA_IMAGE_URL) != '') {
                                    imgUrl.push(course.CA_IMAGE_URL);
                                }
                                if (this.IsNull(course.CA_HASHTAG_ID) != '') {
                                    let item2 = course.CA_HASHTAG_ID.split(',');

                                    for (let j in item2) {
                                        if (this.hashtagsName.indexOf(item2[j]) == -1) {
                                            this.hashtagsName.push(item2[j]);
                                            this.filter2['hashtags'].optionsAll.push({
                                                value: item2[j],
                                                text: item2[j],
                                            });
                                        }
                                    }
                                }
                                this.CourseIf2(course);
                                /*
           let begin = Date.parse(course.CA_BEGIN_TIME).valueOf();
           let end = Date.parse(course.CA_END_TIME).valueOf();
           let beginSignin = Date.parse(course.CA_BEGIN_DATE).valueOf();
           let endSignin = Date.parse(course.CA_END_DATE).valueOf();

           course.courseStatus = [];
           course.courseType = [];
           course.canSignin = false;





           if (course.CA_IS_ENTRUS == 1) {
             course.courseType.push("委訓合作");
           }
           if (course.CS_IS_CREDIT == 1) {
             course.courseType.push("學分班課程");
           } else {
             course.courseType.push("非學分班課程");
           }

           //-----------------------------------------------------------------
           if( curr < begin && course.CA_OPEN =="0" ) {
             // 未達開課時間、未開放報名
             course.courseStatus.push('規劃中')
           } else if (curr < begin) {
             // 未達開課時間
             if (course.CA_IS_END_DATE && curr > endSignin) {
               course.courseStatus.push("已截止");
             } else {
               // 課程未開始招生中
               if (course.CA_IS_BEGIN_DATE && curr > beginSignin) {
                 course.courseStatus.push("招生中");
                 course.canSignin = true;
               } else if (course.CA_IS_BEGIN_DATE && curr < beginSignin) {
                 course.courseStatus.push("規劃中");
               } else {
                 course.courseStatus.push("招生中");
                 course.canSignin = true;
               }
             }
             // 早鳥訊息
             if ( this.IsNull(course.CA_IS_EARLY) && curr < course.CA_EARLY_END_DATE) {
               course.courseStatus.push("早鳥優惠");
             }
             // 已成班
             if (this.IsNull(course.CA_IS_DEFINITE)) {
               course.courseStatus.push("已成班");
             }
           } else if (curr > begin && curr < end) {
             // 課程進行中
             course.courseStatus.push("開課中");
             // 仍可報名
             if (this.IsNull(course.CA_EXTEND)) {
               course.courseStatus.push("仍可報名");
               course.canSignin = true;
             }
           } else {
             course.courseStatus.push("已結束");
           }
           //-----------------------------------------------------------------
           */
                                if (imgUrl.length != 0) {
                                    this.FunctionToken(this.FunctionGetArchive, {
                                        MC_ID: imgUrl,
                                    });
                                }
                            }
                            this.page.set(this.page, courses.length, this.page.count);

                            this.Courses.data = courses;
                            this.Courses.dataAll = courses;
                            this.filterF1();

                            if (imgUrl.length != 0) {
                                this.FunctionToken(this.FunctionGetArchive, {
                                    MC_ID: imgUrl,
                                });
                            }
                        }
                        this.Courses.load = true;
                    }
                })
                .catch((err) => {
                    console.log(err);
                });
        },
        // 取得課程顯示類別
        FunctionGetCategoryListByIndex(data_in) {
            console.log(data_in);
            this.apiGetCategoryListByIndex(data_in)
                .then((res) => {
                    let json = JSON.parse(res.data);
                    if (json.Status) {
                        let categories = JSON.parse(json.Data);
                        let iconUrl = [];
                        this.filter2['categories'].data = categories;
                        for (let i = 0; i < categories.length; i++) {
                            let item = categories[i];
                            this.categoriesName[item.CAT_ID] = item;
                            if (this.IsNull(categories[i].CAT_ICON_URL) != '') {
                                iconUrl.push(categories[i].CAT_ICON_URL);
                            }
                            if (this.IsNull(categories[i].CAT_IMAGE_URL) != '') {
                                iconUrl.push(categories[i].CAT_IMAGE_URL);
                            }

                            if (
                                this.IsNull(this.data_in.CAT_ID) != '' &&
                                this.data_in.CAT_ID == categories[i].CAT_ID
                            ) {
                                this.filter2['categories'].val = this.data_in.CAT_ID;
                            }
                        }

                        if (iconUrl.length != 0) {
                            this.FunctionToken(this.FunctionGetArchive, {
                                MC_ID: iconUrl,
                            });
                        }
                    }
                })
                .catch((err) => {
                    console.log(err);
                });
        },
        // 取得圖片
        FunctionGetArchive(data_in) {
            this.apiGetArchive(data_in)
                .then((res) => {
                    let json = JSON.parse(res.data);
                    if (json.Status) {
                        let data1 = JSON.parse(json.Data);
                        for (let i in data1) {
                            let item = data1[i];
                            this.images[item.MC_ID] = encodeURI([item.SP_PATH_WEB, item.MC_FILE].join(''));
                        }
                        this._watcher.run();
                    }
                })
                .catch((err) => {
                    console.log(err);
                });
        },
    },
};
</script>

<style lang="scss" scoped>
.page {
    min-height: 100vh;
}

.loading {
    background-color: rgba($color: #000000, $alpha: 0.65);
    justify-content: center;
    align-items: center;
    position: fixed;
    display: flex;
    left: 0;
    top: 0;
    z-index: 1005;
    min-width: 100vw;
    min-height: 100vh;
}

header {

    // background-color: #e5f1f8;
    // border-bottom: 1px solid #cbe4f2;
    >.container {
        // padding-top: 7rem;
        // padding-bottom: 2rem;
        background-size: auto 90%;
        background-repeat: no-repeat;
        background-position: right center;
    }
}

.course-results-toolbar {
    display: flex;
    justify-content: flex-end;
    margin-bottom: 1rem;
}

.courses {
    .card-body {
        padding: 1.25rem;
    }
}

.courses.grid {
    .course-figure {
        position: relative;
        display: flex;
        align-items: center;
        justify-content: center;
        overflow: hidden;
    }

    .favorite-icon-button {
        position: absolute;
        top: 1rem;
        right: 1rem;
        z-index: 3;
        border-radius: 999px;
        box-shadow: 0 6px 16px rgba(0, 0, 0, 0.18);
    }

    .course-figure .card-img {
        width: 100%;
        height: 100% !important;
        object-fit: contain !important;
        object-position: center center !important;
    }
}

.course-meta-label {
    color: #555;
    font-size: 0.95rem;
}

.course-recommend-badge {
    vertical-align: middle;
}

.course-category-badge,
.course-category-row .badge {
    background-color: #d8a32b !important;
    color: #fff;
}

.course-price-box {
    display: none;
}

.courses.list {
    .course {
        display: flex;
        flex-direction: row;
        height: auto;
        background-color: #fff;
        border-radius: 15px;
        overflow: hidden;
        border: 1px solid rgba(0, 0, 0, 0.06);
        cursor: pointer;
        transition: border-color 0.2s ease, box-shadow 0.2s ease, transform 0.2s ease;

        &:hover {
            border-color: #0d6efd;
            box-shadow: 0 10px 24px rgba(13, 110, 253, 0.14);
        }
    }

    .course-figure {
        position: relative;
        width: 280px;
        min-width: 280px;
        display: flex;
        align-items: center;
        justify-content: center;
        padding: 0.75rem 0;

        .card-img {
            height: auto !important;
            max-height: 100%;
        }
    }

    .favorite-icon-button {
        position: absolute;
        top: 0.75rem;
        right: 0.75rem;
        z-index: 3;
        border-radius: 999px;
        box-shadow: 0 6px 16px rgba(0, 0, 0, 0.18);
    }

    .card-body {
        display: flex;
        flex-direction: column;
        justify-content: flex-start;
        min-width: 0;
        padding: 1.25rem;
    }

    .card-footer {
        display: flex;
        align-items: center;
        min-width: 220px;
        border-top: 0;
        background-color: transparent;
        padding: 1.5rem 1.75rem 1.5rem 1rem;
    }

    .signin {
        width: 100%;
    }

    .signin > ul {
        display: none;
    }

    .course-price-box {
        display: flex;
        align-items: center;
        justify-content: flex-end;
        gap: 0.9rem;
        width: 100%;
    }

    .course-price-text {
        text-align: right;
        padding-right: 0.35rem;
    }

    .course-price-original {
        color: #666;
        margin-bottom: 0.35rem;
    }

    .old-price {
        color: #999;
        text-decoration: line-through;
    }

    .course-price-current .number {
        color: #ef3f44;
        font-size: 2rem;
        font-weight: 700;
        line-height: 1;
    }

    .course-badge-list {
        flex: 0 0 auto;
        font-size: 1.35rem;
        padding: 0.7rem 1rem;
        border-radius: 8px;
    }

    .course-category-row {
        display: none;
    }
}

@media (max-width: 767.98px) {
    .courses.list {
        .course {
            flex-direction: column;
        }

        .course-figure {
            width: 100%;
            min-width: 0;
        }

        .card-footer {
            min-width: 0;
            padding: 1rem 1.25rem 1.25rem;
        }

        .course-price-box {
            justify-content: space-between;
        }

        .course-price-current .number {
            font-size: 1.6rem;
        }
    }
}
</style>
